import { Navigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Intro } from 'modules/cv-builder';
import { Layout } from 'modules/minimal-ui-theme';
import { FeatureFlag, useFeatureToggle } from 'modules/unleash';

export const CVBuilderPage = () => {
  const theme = useTheme();

  const { isEnabled: isCVBuilderEnabled, isLoading } = useFeatureToggle(
    FeatureFlag.PRO_TALENT_IS_CV_BUILDER_ENABLED
  );

  if (!isCVBuilderEnabled && !isLoading) {
    return <Navigate to="/" />;
  }

  return (
    <Layout
      backgroundColor={theme.palette.background.default}
      childrenStyles={{ pb: 0 }}
    >
      <Intro />
    </Layout>
  );
};
